import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opModal fullModal successModal" }
const _hoisted_2 = { class: "mt-2 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fplogo = _resolveComponent("fplogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_fplogo, { small: true }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text), 1),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary mt-5",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
    }, _toDisplayString(_ctx.okText), 1)
  ]))
}